import {RoutePlanningDriver} from "../../../providers/RoutePlanningProvider";
import {AgStop} from "../../common/types";

export enum AddressType {
  HOME,
  CUSTOM,
  START_LOCATION,
  WAREHOUSE,
  GPS
}

export enum LocationTab {
  START = "START",
  END = "END"
}

export type RowData = RoutePlanningDriver & {
  routeId: string;
  assignedStops: AgStop[];
  endTime: Date | undefined;
  endTimeZone: string | undefined;
  /** Elapsed wall-clock ms from driver start to route end — includes dwell and waiting. */
  duration: number;
  miles: number;
  routeColor: string;
  isVisible: boolean;
  startLat?: number;
  startLng?: number;
  endLat?: number;
  endLng?: number;
  startDateTime?: string;
};

// ===== DP-3039 — Swap or Change Driver dialog =====

/** Active driver outside the planning run ("Other drivers" Change scope). */
export type OtherDriver = {
  driverId: number;
  name: string | null;
  driverCode: string | null;
  vehicleDescription: string | null;
  /** Comma-separated skill ids, as on `Driver.skills` (DP-3230 map skill check). */
  skills: string | null;
};

/** Change-mode dropdown option; routeLabel is null for drivers with no current route. */
export type ChangeDriverOption = {
  driverId: number;
  manifestDriverId?: number;
  driverLabel: string;
  routeLabel: string | null;
};

/** Swap-mode dropdown option — one per route row, so a double-booked driver lists each route. */
export type SwapRouteOption = {
  routeId: string;
  driverLabel: string;
  routeLabel: string;
};
